import { request } from '@mairistem/tools';
import _ from 'lodash';
import React from 'react';

import { getPayeurs, getProduitsJvs } from '@/routes';
import type { ApiResponseType, ProduitJvsType } from '@/types';
import fakeProduits from './produitsJvs';

type UseProduitsJvsType = [ProduitJvsType[] | undefined, boolean];

const useProduitsJvs = (): UseProduitsJvsType => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [produits, setProduits] = React.useState<ProduitJvsType[]>();

  const getAllProduits = React.useCallback(() => {
    const pendingPromises = [];

    setLoading(true);

    // todo mettre en place le service utilisateurs
    const get = process.env.NODE_ENV === 'development' ? getPayeurs : getProduitsJvs;

    request
      .get(get({ page: 1, perPage: 50 }))
      .then(({ data, meta: { lastPage } }: ApiResponseType<ProduitJvsType>) => {
        for (let i = 2; i <= lastPage; i += 1) {
          pendingPromises.push(request.get(get({ page: i, perPage: 50 })));
        }

        Promise.all(pendingPromises)
          .then((datas) => {
            let dataFormatted: ProduitJvsType[] = data;

            _.forEach(datas, ({ data: d }) => {
              dataFormatted = [...dataFormatted, ...d];
            });

            if (process.env.NODE_ENV === 'development') {
              dataFormatted = fakeProduits;
            }

            setProduits(dataFormatted);
          })
          .finally(() => {
            setLoading(false);
          });
      });
  }, []);

  // Récupère tous les produits
  React.useEffect(() => {
    getAllProduits();
  }, [getAllProduits]);

  return [produits, loading];
};

export default useProduitsJvs;
